import React, {useEffect, useState} from "react";
import zoomImg from "../../../../assets/icons/imgBtn.svg";
import BlogImagePopper from "./BlogImageLarge";
import image1 from "../../../../assets/images/Blog61/image1.png";
import image70 from "../../../../assets/images/Blog61/image70.png";
import image71 from "../../../../assets/images/Blog61/image71.png";
import image28 from "../../../../assets/images/Blog61/image28.png";
import image29 from "../../../../assets/images/Blog61/image29.png";
import image18 from "../../../../assets/images/Blog61/image18.png";
import image67 from "../../../../assets/images/Blog61/image67.png";
import image69 from "../../../../assets/images/Blog61/image69.png";
import image81 from "../../../../assets/images/Blog61/image81.png";
import image79 from "../../../../assets/images/Blog61/image79.png";
import image21 from "../../../../assets/images/Blog61/image21.png";
import image65 from "../../../../assets/images/Blog61/image65.png";
import image55 from "../../../../assets/images/Blog61/image55.png";
import image80 from "../../../../assets/images/Blog61/image80.png";
import image63 from "../../../../assets/images/Blog61/image63.png";
import image64 from "../../../../assets/images/Blog61/image64.png";
import image57 from "../../../../assets/images/Blog61/image57.png";
import image76 from "../../../../assets/images/Blog61/image76.png";
import image72 from "../../../../assets/images/Blog61/image72.png";
import image75 from "../../../../assets/images/Blog61/image75.png";
import image89 from "../../../../assets/images/Blog61/image89.png";
const Blog61 = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleRedirect = (url) => {
    window.open(url, "_blank");
  };
  const handleLargeImg = (img) => {
    setSelectedImage(img);
  };
  return (
    <div className="MainNewBlog">
      <div className="blogHeader">
        <h2 className="headerBoldText mainHeader">Weekly Market Outlook – March 23rd, 2026</h2>
      </div>
      <div className="blogContentnew">
        <p className="highlightedText">Supply Shock Dominates, Policy Tightening Persists</p>
        <p>
          Markets are navigating a fragile balance between geopolitical uncertainty and policy rigidity, with price action reflecting hesitation rather than conviction. Early optimism around a
          contained outcome has faded, replaced by a more cautious tone as the week progressed. Liquidity conditions are tightening beneath the surface. Participation remains selective, with flows
          gravitating toward energy and defensive positioning, while broader risk assets struggle to maintain stability.
        </p>
        <p>
          The underlying message is clear: stress is mounting, even if it has not yet fully expressed itself. There is also a noticeable divergence between how markets are positioned and what the
          macro backdrop is implying. While price action has not fully broken down, the underlying tone suggests confidence is thinning, particularly as headline-driven volatility continues to
          dominate.
        </p>

        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Market Overview: Oil Shock Driving Cross-Asset Behaviour</p>
              <p>
                The dominant force across markets is the <span className="highlightedText">energy supply shock, </span> which is now dictating cross-asset performance more than traditional macro
                inputs.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image1}
                    alt="what type of oil crisis"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image1)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>
                The current environment reflects a supply-driven disruption rather than a demand cycle. Oil markets remain tight, with physical constraints limiting the ability for supply to respond
                quickly. This has shifted the macro backdrop toward <span className="highlightedText"> inflation persistence alongside slowing growth expectations, </span> reinforcing stagflation
                concerns.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image70}
                    alt="spx not good when oil crisis is on"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image70)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>
                Equities are reacting accordingly. Historically, oil shocks have created headwinds for equity markets, and recent price action suggests that dynamic is re-emerging. Index performance
                reflects a lack of conviction, with rallies struggling to hold and downside pressure building.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image71}
                    alt="just a typical drawdown so far...who blinks first"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image71)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>
                Flows continue to show a divergence between positioning and reality. While there is still some expectation of stabilisation, price action suggests markets may need further adjustment
                to align with the evolving macro conditions. The inability of equities to decisively rebound highlights{" "}
                <span className="highlightedText">fragile participation rather than strong demand.</span>
              </p>
            </div>
          </div>
        </div>

        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Macro & Policy Watch: Hawkish Policy Meets Supply Constraints</p>
              <p>
                Central banks remain focused on inflation, even as the source of that inflation shifts toward supply-side pressures. The policy framework is still anchored in demand control, while the
                underlying issue is increasingly driven by constrained supply dynamics. This creates a mismatch between policy tools and the actual source of inflation, adding complexity to the macro
                environment.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image28}
                    alt=" major CBs hawkish"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image28)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>
                Rate expectations have adjusted quickly, with markets now pricing tighter policy conditions across major economies. This shift comes despite growing concerns around growth and demand,
                highlighting a disconnect between policy direction and economic sensitivity.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image29}
                    alt="image29 BOE and ECB see hikes priced in"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image29)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>
                The policy response is creating a challenging environment. Tightening financial conditions into a supply shock raises the risk of{" "}
                <span className="highlightedText">demand destruction rather than resolution, </span>
                particularly as energy costs continue to rise and weigh on consumption.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image18}
                    alt="image18 market has tightened conditions already"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image18)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>
                At the same time, geopolitical developments remain unresolved. The lack of a clear de-escalation path keeps uncertainty elevated, reinforcing the sensitivity of markets to headline
                risk and energy price fluctuations. This uncertainty continues to limit conviction across asset classes.
              </p>
            </div>
          </div>
        </div>

        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Technical & Sentiment Breakdown: Supportive, but Increasingly Fragile</p>
              <p>
                Market structure is holding, but momentum is clearly deteriorating. Price action continues to respect key levels, but the quality of moves is weakening, with less follow-through on
                rallies and quicker reactions to downside catalysts. This shift often signals a transitional phase rather than a stable trend.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image67}
                    alt="image67 all aboard the 200dma slide"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image67)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>
                Key indices have moved toward or below critical technical levels, suggesting a transition from trend stability to a more fragile regime. This typically results in
                <span className="highlightedText"> larger and less predictable moves,</span> particularly as liquidity conditions tighten.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image69}
                    alt="image69 once below 200dma moves become bigger both ways"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image69)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>
                Sentiment reflects growing caution. While not fully capitulative, positioning indicates increasing defensiveness, with hedging activity picking up and investors becoming more reactive
                to short-term developments.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image81}
                    alt="image81 vix skew the go to hedge"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image81)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>
                At the same time, consensus appears to be forming around downside risks. This creates the potential for sharp counter-moves, particularly if positioning becomes too one-sided. The
                presence of fear without full capitulation suggests <span className="highlightedText"> that volatility will likely remain elevated.</span>
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image79}
                    alt=" extreme fear"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image79)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Last Week’s Recap: Energy Shock and Policy Tension</p>
              <p>
                The week was defined by a shift from cautious optimism to a more defensive posture amid intensifying macro pressures. Markets were increasingly driven by energy dynamics and policy
                expectations rather than traditional growth signals.
              </p>
              <p className="highlightedText">Key Highlights:</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Macro: </span>
                    <br />
                    Inflation concerns remained elevated, with producer prices surprising to the upside and reinforcing the risk of persistent inflation. Financial conditions tightened meaningfully,
                    adding pressure to growth expectations and increasing sensitivity to further shocks.
                  </p>
                  <div
                    className="imageWrapperCont"
                    style={{marginTop: "22px"}}
                  >
                    <div className="relatedImg">
                      <img
                        src={image21}
                        alt=" Hot PPI.png"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image21)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt="zoom"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">China:</span>
                    <br />
                    Growth concerns continue to linger, with global demand expectations adjusting lower alongside broader macro uncertainty. This adds another layer of fragility, particularly as
                    external demand becomes less reliable.
                  </p>
                  <div
                    className="imageWrapperCont"
                    style={{marginTop: "22px"}}
                  >
                    <div className="relatedImg">
                      <img
                        src={image65}
                        alt=" us far from top 10 heavy now"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image65)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt="zoom"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Earnings:</span>
                    <br />
                    Corporate developments remained secondary to macro forces, with market focus firmly on energy and policy dynamics. Earnings reactions were muted relative to the broader
                    macro-driven moves.
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Commodities:</span>
                    <br />
                    Energy markets surged, driven by supply constraints and geopolitical risks. In contrast, precious metals faced pressure despite their traditional safe-haven role, influenced by
                    rate expectations and ongoing outflows.
                  </p>
                  <div
                    className="imageWrapperCont"
                    style={{marginTop: "22px"}}
                  >
                    <div className="relatedImg">
                      <img
                        src={image55}
                        alt="oil at record breakout pace"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image55)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt="zoom"
                          />
                        </button>
                      </div>
                    </div>
                    <div className="relatedImg">
                      <img
                        src={image80}
                        alt="gold outflows not helping"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image80)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt="zoom"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Crypto: </span>
                    <br />
                    Crypto markets showed relative stability, with price action consolidating rather than breaking down despite broader risk-off sentiment. This suggests a degree of resilience,
                    although direction remains unclear.
                  </p>
                  <div
                    className="imageWrapperCont"
                    style={{marginTop: "22px"}}
                  >
                    <div className="relatedImg">
                      <img
                        src={image63}
                        alt="crypto going sideways"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image63)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt="zoom"
                          />
                        </button>
                      </div>
                    </div>
                    <div className="relatedImg">
                      <img
                        src={image64}
                        alt="btc likes $70k support"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image64)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt="zoom"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Oil:</span>
                    <br />
                    Oil remained the central driver, with prices elevated and volatility driven by geopolitical developments and supply disruptions. The market continues to respond quickly to any
                    changes in the geopolitical narrative.
                  </p>
                  <div
                    className="imageWrapperCont"
                    style={{marginTop: "22px"}}
                  >
                    <div className="relatedImg">
                      <img
                        src={image57}
                        alt="Gulf oil explosions everywhere"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image57)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt="zoom"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">The Week Ahead: Key Data and Market-Moving Signals</p>
              <p>
                The calendar is relatively light, but the focus remains firmly on{" "}
                <span className="highlightedText">inflation signals and early indications of whether the energy shock is feeding through into broader data.</span> Preliminary PMIs across major
                economies will provide insight into growth momentum, while CPI and PPI releases from Australia, Japan, and the UK will be watched for any early transmission effects. By the end of the
                week, <span className="highlightedText">consumer sentiment and inflation expectations data</span> will be key in assessing how deeply current conditions are impacting demand.
              </p>

              <p className="highlightedText">Monday, March 23</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">China:</span> M3 money supply
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Spain:</span> Trade balance
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Chicago Fed national activity index
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Construction spending
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Eurozone:</span> Consumer confidence
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Atlanta Fed GDPNow
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Australia:</span> Manufacturing & Services PMI
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Japan:</span> CPI data (YoY & MoM)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Auctions:</span> France T-bill auctions, US 3-month & 6-month bill auctions
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Central bank speakers:</span> ECB, Bundesbank, BoJ reports
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Tuesday, March 24</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Japan:</span> PMI data (manufacturing, services, composite)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">India:</span> Manufacturing & services PMI
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">France, Germany, Eurozone, UK:</span> PMI releases
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Unit labour costs & productivity
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> S&P Global PMI data
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Richmond Fed indices
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Money supply data
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> API crude oil inventories
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Auctions:</span> Germany, UK, US 2-year note auction
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Central bank speakers:</span> ECB, Fed, SNB, BoJ
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Wednesday, March 25</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Australia:</span> CPI (QoQ, YoY, and trimmed measures)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">UK:</span> CPI, PPI, and RPI releases
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Germany:</span> Ifo business climate and expectations
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Eurozone:</span> ECB President Lagarde speaks
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Mortgage applications and housing indicators
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Import/export price indices
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Crude oil inventories and energy data
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Auctions:</span> US 5-year note auction
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Central bank speakers:</span> ECB, Fed, BoE, RBA
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Thursday, March 26</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Japan:</span> Core CPI and leading indicators
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Germany & France:</span> Consumer and business confidence
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Spain:</span> GDP data
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Eurozone:</span> Money supply and credit data
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Initial and continuing jobless claims
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Kansas City Fed indices
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Fed balance sheet and liquidity data
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Auctions:</span> US 7-year note auction
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Central bank speakers:</span> Fed, ECB, BoE, BoC
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Friday, March 27</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">UK:</span> Retail sales and consumer confidence
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Spain:</span> CPI and inflation data
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Eurozone:</span> ECOFIN meetings
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Michigan consumer sentiment and inflation expectations
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Wholesale inventories
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Canada:</span> Budget balance
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Central bank speakers:</span> Fed and ECB officials
                  </p>
                </li>
              </ul>

              <div
                className="imageWrapperCont"
                style={{marginTop: "22px"}}
              >
                <div className="relatedImg">
                  <img
                    src={image89}
                    alt="EW230326"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image89)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Alpha Takeaway: Fragility Beneath Stability</p>
              <p>
                Markets are balancing between structural support and growing macro pressure, with price action reflecting hesitation rather than resolution. The current environment is defined more by
                <span className="highlightedText"> uncertainty than direction,</span> with multiple forces pulling in different directions.
              </p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Equities:</span>
                    <br />
                    Equities remain sensitive to energy-driven inflation and tightening financial conditions, with downside risks increasing as macro pressures build. Price action suggests limited
                    tolerance for negative surprises.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Gold & Silver:</span>
                    <br />
                    Precious metals are facing conflicting forces, with safe-haven demand offset by rising rate expectations and outflows. This has led to a consolidation of previous gains. Is it
                    re-entry time yet?
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Crypto:</span>
                    <br />
                    Crypto continues to consolidate, showing relative resilience but lacking a clear directional catalyst. Stability here contrasts with broader market volatility but does not yet
                    indicate strength.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Macro:</span>
                    <br />
                    The macro backdrop is increasingly defined by supply constraints and policy tightening, creating a challenging environment for risk assets. The interaction between these forces
                    will likely dictate near-term market direction.
                  </p>
                </li>
              </ul>
              <p className="highlightedText">
                Markets are not yet in full capitulation, but the underlying conditions suggest fragility. The coming sessions will likely determine whether stability can hold or further adjustment is
                required.
              </p>

              <div
                className="imageWrapperCont"
                style={{marginTop: "22px"}}
              >
                <div className="relatedImg">
                  <img
                    src={image76}
                    alt="oil correlation goes negative in a crisis"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image76)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image72}
                    alt="energy still massively under-owned"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image72)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image75}
                    alt="rally time is when oil breaks down"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image75)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="button_wrapper">
          <button
            className="gradientButton_small "
            onClick={() => {
              handleRedirect("https://docs.google.com/document/d/1-Ss4uZlakJf10HNlS8kPPXRTyRZRKVNiKJgJF3mSOOk/edit?tab=t.0");
            }}
          >
            Read In-Depth Market Outlook
          </button>
        </div>
      </div>
      {selectedImage && (
        <BlogImagePopper
          image={selectedImage}
          onClose={() => handleLargeImg(null)}
        />
      )}
    </div>
  );
};

export default Blog61;
